module.exports = __webpack_public_path__ + "img/한티역 미용실.944da362.png";